var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-table-design',{staticClass:"offers-table",attrs:{"items":_vm.items,"headers":_vm.headers,"loading":_vm.loading,"total-element-data-table":_vm.total,"routes":_vm.routes,"unique-data":_vm.uniqueData,"actions":_vm.actions},on:{"get-page-data":_vm.submitData}})
}
var staticRenderFns = []

export { render, staticRenderFns }